// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === "t") return "static/css/t.a3ac268b.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}